import { axios, BaseApiUrl } from '../axios_config';

// 查询用户是否设置打印机
export const GetPrinterByUser = params =>{
    return axios.get(`${BaseApiUrl}/UserPrinter/GetPrinterByUser`, { params }).then(res => res.data);
}

// 新增用户打印机
export const AddUserPrinter = params =>{
    return axios.post(`${BaseApiUrl}/UserPrinter/AddUserPrinter`, { ...params }).then(res => res.data);
}
